import {http as httpApiGateway} from "./api/restApiClient";

/**
 * Template API service — routes template requests through the REST API Gateway
 * to the template_api Lambda.
 */
export const DocumentService = {
  getTemplateNames: () => httpApiGateway.get("/templates"),

  getTemplate: (templateId: string) =>
    httpApiGateway.get(`/templates/${templateId}/template`),

  getLatestTemplateVersion: (facilityId: string) =>
    httpApiGateway.get(`/templates/facility/${facilityId}/current`),

  getTemplateVersion: (facilityId: string, versionId: string) =>
    httpApiGateway.get(`/templates/facility/${facilityId}/versions/${versionId}`),

  getPreflightTemplate: (templateId: string) =>
    httpApiGateway.get(`/templates/${templateId}/preflight`),

  getFacilitySettingsTemplate: (templateId: string) =>
    httpApiGateway.get(`/templates/${templateId}/facility-settings`),

  getPreludeExperienceTemplate: (templateId: string) =>
    httpApiGateway.get(`/templates/${templateId}/prelude`),
};
